import { useState } from 'react';
import { MaterialsTab } from './MaterialsTab';
import { RecipesTab } from './RecipesTab';
import { AplicacionesTab } from './AplicacionesTab';
import { ManoDeObraTab } from './ManoDeObraTab';
import { InsumosTab } from './InsumosTab';

type ModuleTab = 'recetas' | 'materiales' | 'mdo' | 'aplicaciones' | 'insumos';

const TABS: { key: ModuleTab; label: string }[] = [
  { key: 'recetas', label: 'APUs' },
  { key: 'materiales', label: 'Materiales' },
  { key: 'mdo', label: 'Mano de Obra' },
  { key: 'aplicaciones', label: 'Categoría' },
  { key: 'insumos', label: 'Insumos' },
];

export function RecetasPage() {
  const [moduleTab, setModuleTab] = useState<ModuleTab>('recetas');

  return (
    <div className="space-y-6 fade-up-1">
      {/* Module Tab Switcher */}
      <div className="flex items-center gap-4 border-b border-gray-200">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`pb-2 text-sm font-medium transition-colors ${
              moduleTab === tab.key
                ? 'border-b-2 border-brand-blue text-brand-blue'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setModuleTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {moduleTab === 'recetas' && <RecipesTab />}
      {moduleTab === 'materiales' && <MaterialsTab />}
      {moduleTab === 'mdo' && <ManoDeObraTab />}
      {moduleTab === 'aplicaciones' && <AplicacionesTab />}
      {moduleTab === 'insumos' && <InsumosTab />}
    </div>
  );
}
